export enum ExportActionEnum{
    Download,
    Print,
    Email,
}